import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DisplayPicture from "../DisplayPicture/DisplayPicture";

import groupImage from "../../assets/Images/groupImage.png";
import gymImage from "../../assets/Images/gym.png";
import trackImage from "../../assets/Images/track.png";
import workoutImage from "../../assets/Images/workout.png";
import subscriptionImage from "../../assets/Images/subscription.png";

import { NotificationEnum } from "../../assets/Js/notificationEnum";
export default function NotifcationCard({
  image,
  title,
  description,
  body,
  type,
  handleNotification,
}) {
  const [localImage, setLocalImage] = useState(workoutImage);

  useEffect(() => {
    let _notificationImage = localImage;

    switch (type) {
      case NotificationEnum.Workout:
        _notificationImage = workoutImage;
        break;
      case NotificationEnum.Subscription:
        _notificationImage = subscriptionImage;
        break;
      case NotificationEnum.Message:
      case NotificationEnum.RemovedFromGroup:
        _notificationImage = groupImage;
        break;
      default:
        _notificationImage = workoutImage;
        break;
    }
    setLocalImage(_notificationImage);
  }, []);

  const localHandleNotification = () => {
    handleNotification(body, type);
  };

  return (
    <a className="dropdown-item d-flex" onClick={localHandleNotification}>
      <div className="item-thumbnail">
        <DisplayPicture
          isLocalImage={true}
          image={localImage}
          className="profileLogo"
        />
      </div>
      <div className="item-content notificationContent">
        <h6 className="font-weight-normal">{title}</h6>
        <p className="font-weight-light small-text mb-0 text-muted">
          {description}
        </p>
      </div>
    </a>
  );
}

NotifcationCard.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  handleNotification: PropTypes.func,
};
